import { Box, TableCell } from "@mui/material";
import { useNavigate } from "react-router-dom";
import StyledTableRow from "../../../components/table/styled-table-row";
import { useState } from "react";
import BiometricDeviceForm from "./biometric-device-form";
import { ConfirmationDialog } from "../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectLoggedInUser } from "../../auth/auth.slice";
import TableActionButton from "../../../components/table/table-action-button";
import { EditIcon, DeleteIcon, PeopleIcon, FingerprintIcon } from "../../../shared/icons";
import { BiometricDevice, BiometricDeviceRequest } from "../../../service/model/biometric.model";
import * as BiometricDeviceSlice from "../biometric-device.slice";
import { getPermissionsForLoggedInUser } from "../../../shared/utils";
import { PermissionCode } from "../../../shared/enums";

interface TableRowProps {
    readonly device: BiometricDevice
}

const BiometricDeviceTableRow: React.FC<TableRowProps> = ({ device }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showBiometricDeviceForm, setShowBiometricDeviceForm] = useState(false);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUserPermissions = getPermissionsForLoggedInUser(loggedInUserDetails);
    const loggedInUser = loggedInUserDetails?.user;

    const handleDelete = () => {
        dispatch(BiometricDeviceSlice.deleteBiometricDevice(device.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: BiometricDeviceRequest) => {
        loggedInUser && dispatch(BiometricDeviceSlice.updateBiometricDevice({ ...data, id: device.id })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowBiometricDeviceForm(false);
            }
        });
    };

    return (
        <>
            <StyledTableRow key={device.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Serial Number</Box>{device.serialNumber}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Device Name</Box>{device.deviceName}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Model (Days)</Box>{device.model}</TableCell>
                {/* <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Expiry</Box>{node.branch.createdDate}</TableCell> */}
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    <TableActionButton onClick={() => navigate(`/devices/${device.id}/users`)} label="View users" icon={<PeopleIcon />} />
                    <TableActionButton onClick={() => navigate(`/devices/${device.id}/transactions`)} label="View biometric transactions" icon={<FingerprintIcon />} />
                    {loggedInUserPermissions.includes(PermissionCode.BIOMETRIC_DEVICE_EDIT) &&
                        <TableActionButton onClick={() => setShowBiometricDeviceForm(true)} label="Edit" icon={<EditIcon />} />
                    }
                    {loggedInUserPermissions.includes(PermissionCode.BIOMETRIC_DEVICE_DELETE) &&
                        <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} />
                    }
                </TableCell>
            </StyledTableRow>
            {showBiometricDeviceForm &&
                <BiometricDeviceForm device={device} editable={true} onClose={() => setShowBiometricDeviceForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default BiometricDeviceTableRow;